import React from 'react'
import { useCart } from 'lib/core/hooks/useCart'
import { useCartItems } from 'hooks/cart'
import { ItemData } from 'components/ItemData'
import { Container } from './styled'

interface Props {
  isMiniCart?: boolean
}

export const Products = ({ isMiniCart }: Props) => {
  const { cart, count } = useCart()
  const cartItems = useCartItems(cart?.data?.items)

  if (!count) {
    return null
  }

  return (
    <Container>
      {cartItems?.map((item, index) => {
        const SubItem = item?.associatedProduct
        const [sampleDuration] = item.product.customAttribute?.promotion_days ?? []
        const isSubscriptionItem = Boolean(item.frequencyInCart ?? SubItem.frequencyInCart)
        if (SubItem?.id) {
          return (
            <>
              <ItemData
                key={index}
                cartItem={item}
                hasVariant={!!item?.variantProduct}
                variantOptions={item?.configurableOptions}
                index={index}
                itemQty={item.quantity}
                imageUrl={SubItem.product.image?.default.url}
                isSpecialSupply
                isMiniCart={isMiniCart}
              />
              <ItemData
                key={index}
                cartItem={SubItem}
                hasVariant={!!SubItem?.variantProduct}
                variantOptions={SubItem?.configurableOptions}
                index={index}
                itemQty={SubItem.quantity}
                isChildren
                isSubscriptionItem={isSubscriptionItem}
                sampleDuration={sampleDuration}
                isMiniCart={isMiniCart}
              />
            </>
          )
        }
        return (
          <ItemData
            key={index}
            cartItem={item}
            hasVariant={!!item?.variantProduct}
            variantOptions={item?.configurableOptions}
            index={index}
            itemQty={item.quantity}
            imageUrl={item.product.image?.default.url}
            isSubscriptionItem={isSubscriptionItem}
            isMiniCart={isMiniCart}
          />
        )
      })}
    </Container>
  )
}
